import React from 'react';
import PublicPageLayout from '../components/landing-page/PublicPageLayout';

const useCases = [
  {
    title: 'SaaS Launch Pricing',
    body: 'Validate early-stage pricing quickly by testing starter, growth, and premium combinations before committing to a public launch.',
  },
  {
    title: 'Annual Plan Adoption',
    body: 'Measure how discount strategy and anchor prices change annual plan adoption without lowering overall revenue quality.',
  },
  {
    title: 'Expansion Revenue',
    body: 'Optimize multi-tier monetization for existing product lines to increase account expansion and reduce pricing friction.',
  },
  {
    title: 'International Packaging',
    body: 'Run region-aware price experiments to understand local willingness-to-pay while keeping product packaging consistent.',
  },
];

export default function UseCasesPage() {
  return (
    <PublicPageLayout title='Use Cases' subtitle='How teams use pricing experiments to make better monetization decisions.'>
      <div className='grid gap-4 md:grid-cols-2'>
        {useCases.map((item) => (
          <article key={item.title} className='rounded-lg border border-gray-700 bg-gray-900/40 p-5'>
            <h2 className='text-lg font-semibold text-white'>{item.title}</h2>
            <p className='mt-2 text-sm leading-6 text-gray-300'>{item.body}</p>
          </article>
        ))}
      </div>
    </PublicPageLayout>
  );
}
